import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styled from 'styled-components';
import { useSnackbar } from 'notistack';
import { LinearProgress } from '@material-ui/core';
import { Box } from 'reflexbox';

import { ROUTES } from '../../../Routes/constants';
import { HealtheraButton } from '../../../../healtheraComponents';
import PushNotificationDetails from './PushNotificationDetails/PushNotificationDetails';

const validationSchema = Yup.object().shape({
  title: Yup.string().optional(),
  body: Yup.string().optional(),
  app_deep_link: Yup.string().optional(),
  note: Yup.string().optional(),
  file: Yup
    .mixed()
    .test(
      'fileType',
      'File must be in CSV format.',
      function (value) {
        if (!value || !value.name.endsWith('.csv')) return true;
        return value && value.type === 'text/csv';
      }
    )
    .test(
      'fileSize',
      'File size must not exceed 18MB',
      function (value) {
        if (!value) return true;
        return value.size <= 18 * 1024 * 1024;
      }
    ),
});

const EditPushNotification = ({ campaign, appDeepLinks, onSubmit, error, isUpdating }) => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [updatedFields, setUpdatedFields] = useState(null);
  const [isLocallyUpdating, setIsLocallyUpdating] = useState(false);

  const { setValues, values, errors: validationErrors, validateForm } = useFormik({
    initialValues: campaign,
    validationSchema,
  });
  
  useEffect(() => {
    validateForm();
  }, [validateForm]);

  useEffect(() => {
    if (isLocallyUpdating && !isUpdating && !error) {
      setIsLocallyUpdating(false);
      history.push(ROUTES.CAMPAIGNS);
    } else if (isLocallyUpdating && !isUpdating && error) {
      setIsLocallyUpdating(false);
    }
  }, [history, error, isLocallyUpdating, isUpdating]);

  const changeHandler = updatedCampaign => {
    const { ...campaignUpdate } = updatedCampaign;

    setValues({
      ...values,
      ...campaignUpdate,
    });

    setUpdatedFields({
      ...updatedFields,
      ...campaignUpdate,
    });
  };

  const handleSubmit = () => {
    const [error] = Object.values(validationErrors);
    if (error) {
      enqueueSnackbar(error, { variant: 'error' });
    } else {
      setIsLocallyUpdating(true);
      onSubmit({ _id: campaign._id, ...updatedFields });
    }
  };

  return (
    <>
      {isLocallyUpdating &&
        <Box sx={{ width: '50%' }}>
          <LinearProgress color='secondary' />
        </Box>
      }
      <PushNotificationDetails
        campaign={values}
        appDeepLinks={appDeepLinks}
        onUpdate={changeHandler}
        disabled={isLocallyUpdating || campaign?.status === 'sent'}

      />
      <ButtonContainer>
        <HealtheraButton
          disabled={!updatedFields || campaign?.status === 'sent'}
          onClick={handleSubmit}
        >
          Save Draft
        </HealtheraButton>
      </ButtonContainer>
    </>
  );
};

const ButtonContainer = styled.div`
  border-radius: 15px;
  margin-top: 20px;
  padding: 20px;
  width: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 20px;
`;

export default EditPushNotification;
